import moment from 'moment'
import { findRouteColor } from '@/config/routeColors'

const getColorByHex = hex => {
  const color = findRouteColor(hex)
  return { name: color.name, hex: color.hex || color.value }
}

const getColorByName = name => {
  const color = findRouteColor(name)
  return { name: color.name, hex: color.hex || color.value }
}

const indexOf = (array, obj, fn) => {
  if (!array) return -1

  if (!fn || typeof fn !== 'function') return array.indexOf(obj)

  for (let i = 0; i < array.length; i++) {
    if (fn(array[i], obj)) {
      return i
    }
  }

  return -1
}

const copyTextToClipboard = text => {
  const textArea = document.createElement("textarea")

  // Place in top-left corner of screen regardless of scroll position.
  textArea.style.position = 'fixed'
  textArea.style.top = 0
  textArea.style.left = 0

  // Ensure it has a small width and height. Setting to 1px / 1em
  // doesn't work as this gives a negative w/h on some browsers.
  textArea.style.width = '2em'
  textArea.style.height = '2em'

  // We don't need padding, reducing the size if it does flash render.
  textArea.style.padding = 0

  // Clean up any borders.
  textArea.style.border = 'none'
  textArea.style.outline = 'none'
  textArea.style.boxShadow = 'none'

  // Avoid flash of white box if rendered for any reason.
  textArea.style.background = 'transparent'

  textArea.value = text

  document.body.appendChild(textArea)

  textArea.select()

  try {
    // const successful = document.execCommand('copy')
    document.execCommand('copy')
    // const msg = successful ? 'successful' : 'unsuccessful'
    //console.log('Copying text command was ' + msg)
  } catch (err) {
    console.log('Oops, unable to copy', err)
  }

  document.body.removeChild(textArea);
}

const normalizeApiMontageDate = montageDate => {
  if (!montageDate) return montageDate
  if (/^\d{2}-\d{2}-\d{4}$/.test(montageDate)) return montageDate

  const parsedDate = moment(montageDate, [moment.ISO_8601, 'YYYY-MM-DD', 'DD-MM-YYYY'], true)
  if (!parsedDate.isValid()) return montageDate

  return parsedDate.format('DD-MM-YYYY')
}

const normalizeApiMontageTime = montageTime => {
  if (!montageTime) return montageTime
  if (/^\d{2}:\d{2}$/.test(montageTime)) return montageTime

  const isoTimeMatch = String(montageTime).match(/T(\d{2}:\d{2})/)
  if (isoTimeMatch) return isoTimeMatch[1]

  const fullTimeMatch = String(montageTime).match(/^(\d{2}:\d{2})(:\d{2})?$/)
  if (fullTimeMatch) return fullTimeMatch[1]

  return montageTime
}

export {
  getColorByHex,
  getColorByName,
  indexOf,
  copyTextToClipboard,
  normalizeApiMontageDate,
  normalizeApiMontageTime
}
